export default __webpack_public_path__ + "static/char-s-14-jp-d5f8076df37462fb0b65545e9d31c4a7.png";